interface GeometricGridBackgroundProps {
  isDark: boolean;
  opacity?: number;
  className?: string;
}

/** Board-game table texture: a loose grid of printed dots. */
export function GeometricGridBackground({
  isDark,
  opacity = 0.03,
  className = "",
}: GeometricGridBackgroundProps) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        // The old grid was tuned for 1px lines; dots need more presence.
        opacity: Math.min(1, opacity * 6),
        backgroundImage: `radial-gradient(${isDark ? "var(--color-zinc-700)" : "var(--color-gray-300)"} 2px, transparent 2.5px)`,
        backgroundSize: "28px 28px",
      }}
    />
  );
}
